// extracted by mini-css-extract-plugin
export default {"image":"multimedia-gallery_image__b-7Jd","video":"multimedia-gallery_video__2KLDv"};